import { useEffect } from 'react';
import { FormProvider } from 'react-hook-form';
import { Alert, Box, Button, Center, Screen } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { OutlineWarning01Icon } from '@tempmee/react-icons';
import { BackButton } from '~/commonComponents';
import ConfirmPopup from '../shared/ConfirmPopup';
import { CollapsibleCardsGroup } from './components/CollapsibleCardsGroup/CollapsibleCardsGroup';
import { useAccountInformation } from './hooks/useAccountInformation/useAccountInformation';

export const AccountInformation = () => {
  const {
    methods,
    onSubmit,
    isLoading,
    isButtonDisabled,
    isValid,
    confirmationExitModalOpen,
    setConfirmationExitModalOpen,
    navigateToPending,
    clearPendingNavigation,
  } = useAccountInformation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Screen variant="standard">
        <Screen.Header start={<BackButton />} title="Account Information" />
        <Screen.Body inset>
          {!isValid && (
            <Box style={{ marginBottom: -8 }}>
              <Alert
                severity="warning"
                description="Missing information: Complete missing fields for higher chances of filling shifts."
              />
            </Box>
          )}

          <FormProvider {...methods}>
            <CollapsibleCardsGroup />

            <Center style={{ marginTop: 60 }}>
              <Button
                disabled={isButtonDisabled}
                size="md"
                onClick={onSubmit}
                isLoading={isLoading}
              >
                Save
              </Button>
            </Center>
          </FormProvider>
        </Screen.Body>
      </Screen>

      {/* DS ConfirmationModal truncates "Leave Anyway" — Button sm uses fixed w-[140px] */}
      {confirmationExitModalOpen && (
        <ConfirmPopup
          Icon={() => <OutlineWarning01Icon size={80} color={colors.warning[500]} />}
          leftButtonAction={() => {
            clearPendingNavigation();
            setConfirmationExitModalOpen(false);
          }}
          leftButtonText="Go Back"
          rightButtonAction={navigateToPending}
          rightButtonText="Leave Anyway"
          title="Are You Sure You Want to Leave?"
          titleStyle={{ marginBottom: 20, marginTop: 20 }}
          descriptionStyle={{ marginBottom: 40 }}
          description="Updates made to your account information haven't been saved. Do you still want to leave?"
        />
      )}
    </>
  );
};
